var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDholakiaVentures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 188.419,
    height: 46,
    viewBox: "0 0 188.419 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 188.419,
    height: 46,
    fill: "#1579be"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13219",
    "data-name": "Group 13219",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M11.393.922H0V22.03l4.222-3.857L4.253,5.127V5.11h7.124c5.906,0,9.611,3.571,9.611,9.278,0,5.673-3.688,9.227-9.561,9.227l-7.2.1L0,27.82H11.393c8.543,0,13.866-5.156,13.866-13.416,0-8.326-5.323-13.5-13.866-13.482",
    transform: "translate(0 -0.428)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M69.018,12.374H57.372V3.217l-4.2-2.189v26.9h4.2V16.562H69.018V27.925H73.24V3.217L69.018,1.028Z",
    transform: "translate(-24.662 -0.477)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M111.287.156A13.9,13.9,0,1,0,125.2,14.105,13.954,13.954,0,0,0,111.287.156m-.017,23.527a9.636,9.636,0,1,1,9.661-9.611,9.638,9.638,0,0,1-9.661,9.611",
    transform: "translate(-45.174 -0.072)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M160.263,3.216,156.04,1.027v26.9h15.147l2.189-4.2H160.263Z",
    transform: "translate(-72.382 -0.477)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M290.138,27.925h4.222V3.216l-4.222-2.189Z",
    transform: "translate(-134.585 -0.477)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M202.726,0,190.078,27.449h4.572l8.21-18.221,8.193,18.221h4.572L202.976,0Z",
    transform: "translate(-88.171 0)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M316.689,0h-.25L303.791,27.449h4.572l8.209-18.221h0l8.193,18.221h4.572Z",
    transform: "translate(-140.918 0)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M244.506,27.925h4.205V3.216l-4.205-2.189Z",
    transform: "translate(-113.418 -0.477)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M269.207,1.027H264.3l-9.244,12.882v1L265,27.925h5.156l-10.5-13.7Z",
    transform: "translate(-118.312 -0.477)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M80.553,77.763l-3.83-9.1h1.25l2.574,6.215,2.58-6.215H84.4Z",
    transform: "translate(-35.589 -31.848)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M111.207,68.623v1.2H107.28v2.732h2.944v1.2H107.28V76.49h3.927v1.2h-5.136V68.623Z",
    transform: "translate(-49.203 -31.832)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M136.571,74.685V68.56h1.208v9.209l-5.894-6.283v6.143h-1.208V68.487Z",
    transform: "translate(-60.616 -31.769)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M162.95,68.658h2.027v1.2h-2.409v7.831H161.36V69.853H158.95v-1.2h4Z",
    transform: "translate(-73.731 -31.848)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M192.37,68.658v5.548a3.592,3.592,0,0,1-.255,1.372,3.633,3.633,0,0,1-.789,1.153v.006a3.566,3.566,0,0,1-1.16.783,3.515,3.515,0,0,1-1.366.261,3.618,3.618,0,0,1-1.378-.255,3.4,3.4,0,0,1-1.16-.8,3.506,3.506,0,0,1-.789-1.153,3.6,3.6,0,0,1-.255-1.372V68.658h1.22V74.2a2.325,2.325,0,0,0,.176.9,2.368,2.368,0,0,0,.516.759,2.227,2.227,0,0,0,.765.516,2.278,2.278,0,0,0,.9.176,2.344,2.344,0,0,0,.892-.176,2.283,2.283,0,0,0,.759-.516,2.234,2.234,0,0,0,.7-1.657V68.658Z",
    transform: "translate(-85.916 -31.848)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M214.262,68.657h2.817a3.442,3.442,0,0,1,1.275.237,3.139,3.139,0,0,1,1.019.649,3,3,0,0,1,.644.893,2.63,2.63,0,0,1,.194,1.062v.255a2.575,2.575,0,0,1-.139.862,3.413,3.413,0,0,1-.413.783,2.091,2.091,0,0,1-.449.48,2.353,2.353,0,0,1-.558.292l-.425.169.249.389,1.906,2.956h-1.5l-2.058-3.163h-1.335v3.163h-1.214Zm3,4.656.006.006a1.619,1.619,0,0,0,.65-.122,1.859,1.859,0,0,0,.516-.383,1.628,1.628,0,0,0,.388-.583,1.752,1.752,0,0,0,.116-.673,1.792,1.792,0,0,0-.116-.656,1.961,1.961,0,0,0-.382-.546v-.006a1.664,1.664,0,0,0-.655-.376,2.592,2.592,0,0,0-.826-.128h-1.481v3.46h.376l.455.006h.953Z",
    transform: "translate(-99.389 -31.848)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M245.837,68.623v1.2H241.91v2.732h2.943v1.2H241.91V76.49h3.927v1.2H240.7V68.623Z",
    transform: "translate(-111.653 -31.832)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M267.827,76.361a1.909,1.909,0,0,0,.486-.281,1.334,1.334,0,0,0,.349-.43,1.166,1.166,0,0,0,.132-.546.943.943,0,0,0-.1-.454,1.2,1.2,0,0,0-.272-.36,2.029,2.029,0,0,0-.411-.277,3.6,3.6,0,0,0-.466-.209q-.222-.08-.489-.153a4.776,4.776,0,0,1-1.066-.428,2.876,2.876,0,0,1-.819-.687,2.157,2.157,0,0,1-.372-.651,2.208,2.208,0,0,1-.131-.756,2.582,2.582,0,0,1,.76-1.839,2.606,2.606,0,0,1,1.85-.764,2.567,2.567,0,0,1,.922.167,2.6,2.6,0,0,1,.789.471,2.53,2.53,0,0,1,.8,1.26l-1.205.254a1.387,1.387,0,0,0-.325-.512,1.352,1.352,0,0,0-1.495-.3,1.393,1.393,0,0,0-.442.3,1.426,1.426,0,0,0-.3.444,1.311,1.311,0,0,0-.108.526,1.158,1.158,0,0,0,.212.672,1.237,1.237,0,0,0,.241.241,2.162,2.162,0,0,0,.286.19,3.3,3.3,0,0,0,.33.151q.191.077.331.121l.331.105c.128.04.224.071.291.095a4.576,4.576,0,0,1,.628.277,3.589,3.589,0,0,1,.571.381,2.841,2.841,0,0,1,.471.48,2.112,2.112,0,0,1,.316.584,2.008,2.008,0,0,1,.118.685,2.354,2.354,0,0,1-.232,1.022,2.636,2.636,0,0,1-.611.833,2.964,2.964,0,0,1-.882.548,2.712,2.712,0,0,1-1.03.2,2.777,2.777,0,0,1-1.124-.237,2.826,2.826,0,0,1-.949-.673,2.55,2.55,0,0,1-.578-.991l1.212-.257a1.432,1.432,0,0,0,.578.666,1.581,1.581,0,0,0,.856.258,1.833,1.833,0,0,0,.55-.129",
    transform: "translate(-122.753 -31.786)",
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDholakiaVentures);
export default __webpack_public_path__ + "static/media/DholakiaVentures.463ee8f26a72cdf0c7f0fba5513eee82.svg";
export { ForwardRef as ReactComponent };